import React from 'react';
import { PillBackground } from '../PillBackground';
import { SingleDragOption } from './shared/SingleDragOption';

export interface DragOptionsProps {
  options: (string | number)[];
  onOptionClick?: (value: string) => void;
}

/**
 * DragOptions widget — displays a panel of draggable answer chips.
 * Chips can be dragged to input fields or clicked to select.
 * Shows empty slots for chips that are currently in use.
 *
 * Uses SingleDragOption for each chip so the chip logic is shared
 * with the InlineDragOption widget.
 */
export const DragOptions: React.FC<DragOptionsProps> = ({
  options,
  onOptionClick,
}) => {
  return (
    <PillBackground>
      <div className="drag-options">
        {options.map((option, idx) => {
          const optionId = `drag-option-${idx}`;
          const optionValue = String(option);

          return (
            <SingleDragOption
              key={optionId}
              optionId={optionId}
              value={optionValue}
              onOptionClick={onOptionClick}
            />
          );
        })}
      </div>
    </PillBackground>
  );
};
